import { EffectComposer, ToneMapping, Noise, Bloom } from '@react-three/postprocessing'
import { BlendFunction, KernelSize, ToneMappingMode, Resolution } from 'postprocessing'

export default function PostProcessing()
{
  return (
    <EffectComposer stencilBuffer disableNormalPass autoClear={false}>

      {/* Tone Mapping */}
      <ToneMapping
          blendFunction={BlendFunction.SRC}
          mode={ToneMappingMode.REINHARD}
          resolution={new Resolution(512, 512)}
      />

      {/* Bloom Effect */}
      <Bloom
          blendFunction={BlendFunction.SCREEN}
          radius={0.9}
          kernelSize={KernelSize.VERY_LARGE}
          luminanceThreshold={1}
          luminanceSmoothing={1}
          intensity={0.25}
          levels={6}
          mipmapBlur={true}
          resolutionX={Resolution.AUTO_SIZE}
          resolutionY={Resolution.AUTO_SIZE}
      />

      {/* Noise Effect */}
      <Noise
          blendFunction={BlendFunction.OVERLAY}
          opacity={0.15}
      />

    </EffectComposer>
  )
}
